import { useRef, useState, useContext, useEffect } from "react";

import { fetchCountries } from "../../Context/Country/action";
import { CountryContext } from "../../Context/Country/context";
import clsx from "clsx";
import { ReactComponent as Logo } from "../../Assets/Icons/logo.svg";
import { ReactComponent as Menu } from "../../Assets/Icons/menu.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/close.svg";
import navList from "./navList";

import { Link } from "react-router-dom";
import routes from "../../utils/routes";
import "./nav.css";
import Sidebar from "./Sidebar";
import DesktopNav from "./DesktopNav";
import DesktopCountryDropdown from "./Dropdowns/DesktopCountry";

const Navigation = ({ appNav }) => {
  const { countryState, dispatch } = useContext(CountryContext);

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const sideBarToggler = useRef(null);
  const innerDropdownToggler = useRef(null);
  const desktopDropdownToggler = useRef(null);
  const desktopDropdownWrapper = useRef(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [dropdownState, setDropdownState] = useState({
    isDropdownOpen: false,
    content: "",
  });

  const toggleSideBar = (e) => {
    if (sideBarToggler.current) {
      sideBarToggler.current.checked = !sideBarToggler.current.checked;
    }
    if (innerDropdownToggler.current) {
      innerDropdownToggler.current.checked = false;
    }
    setIsSidebarOpen((prev) => !prev);
  };

  const closeDesktopDropdown = (e) => {
    if (desktopDropdownToggler.current) {
      desktopDropdownToggler.current.checked = false;
    }
    window.removeEventListener("click", closeDesktopDropdown);
    return setTimeout(() => {
      setDropdownState({
        isDropdownOpen: false,
        content: "",
      });
    }, 300);
  };

  const toggleDropdown = (e, content) => {
    e.stopPropagation();
    if (!desktopDropdownToggler.current.checked) {
      desktopDropdownToggler.current.checked = true;
      window.addEventListener("click", closeDesktopDropdown);
      setDropdownState((prev) => ({
        ...prev,
        isDropdownOpen: !dropdownState?.isDropdownOpen,
        content,
      }));
    } else {
      closeDesktopDropdown();
    }
  };

  return (
    <>
      <input ref={desktopDropdownToggler} className="toggler" type="checkbox" />
      <div
        ref={desktopDropdownWrapper}
        className="hidden slg:block fixed top-0 left-0 w-full bg-white mt-61  toggled3  shadow-sub desktopNavDropdown"
      >
        <div className="z-10">
          {dropdownState?.content === "Countries" && (
            <DesktopCountryDropdown countries={countryState?.countries} />
          )}
        </div>
      </div>
      <nav className="bg-white  font-poppins text-metal  z-20  w-full fixed ">
        <div
          className={clsx({
            "flex bg-white items-center justify-between h-54 md:h-61 layout__wrapper ": true,
            "fixed z-50 w-full slg:relative": isSidebarOpen,
          })}
        >
          <Link to={routes.home}>
            <Logo />
          </Link>
          <button
            onClick={toggleSideBar}
            className="outline-none menu__toggler focus:outline-none slg:hidden"
          >
            {!isSidebarOpen ? <Menu /> : <CloseIcon />}
          </button>
          <input ref={sideBarToggler} className="toggler" type="checkBox" />
          <div
            id="mobile"
            className="mt-54 md:mt-61 slg:hidden fixed bg-white top-0  w-full h-screen z-50 toggled"
          >
            <Sidebar
              innerDropdownToggler={innerDropdownToggler}
              countries={countryState?.countries}
              navList={navList(appNav)}
              toggleSideBar={toggleSideBar}
            />
          </div>
          <DesktopNav
            openedDropdown={dropdownState?.content}
            toggleDropdown={toggleDropdown}
            navList={navList(appNav)}
          />
        </div>
      </nav>
      <div
        className={clsx({
          "h-54 md:h-61  -z-1": true,
        })}
      ></div>
    </>
  );
};

export default Navigation;
